import AdminForm from "./form";
export default AdminForm;
